import { initialState, AcceptedServicesState, acceptedServicesAdapter } from './accepted-services.interfaces';
import * as fromAcceptedServices from './accepted-services.actions';
export function reducer(
  state = initialState,
  action: fromAcceptedServices.AcceptedServiceAction
): AcceptedServicesState {
  switch (action.type) {
    case fromAcceptedServices.ADD_ACCEPTED_SERVICE_IN_STATE: {
      return {
        ...acceptedServicesAdapter.addOne(action.payload.serviceGroup, state)
      };
    }
    case fromAcceptedServices.REMOVE_ACCEPTED_SERVICE_IN_STATE: {
      return {
        ...acceptedServicesAdapter.removeOne(action.payload.id, state)
      };
    }
    case fromAcceptedServices.CLEAR_ACCEPTED_SERVICE_IN_STATE: {
      return initialState
    }
    default: {
      return state;
    }
  }
}
